import Modal from 'ds/components/modal';
import React from 'react';
import { HostedFieldsProps, TranzilaModalType } from './types';
import { PaymentButton, Wrapper } from './styled';
import { useLocale } from 'locale';
import { useScreenBreakpoint } from 'consts/breakpoints';
import { PaymentMethod } from 'store/state/app';
import { logAndTrackError } from 'helpers/jstracking';
import { SpacingBlock } from 'components/spacing-block';
import GoogleIcon from 'assets/svg/google.svg';
import CardIcon from 'assets/svg/credit-card.svg';
import { PromotionPlanVariant } from 'store/sagas/apiService/types';


type CardInfo = Pick<HostedFieldsProps, 'toggleModal' | 'handshakeState' | 'onPaymentSubmit' | 'isGoogleEnable' | 'setModal' | 'modalState'>;

export const Method: React.FC<CardInfo> = ({
  toggleModal,
  handshakeState,
  onPaymentSubmit,
  isGoogleEnable,
  setModal,
  modalState,
}) => {
  const { t } = useLocale();
  const screen = useScreenBreakpoint();
  const isDesktop = screen >= 3;

  const paymentData = handshakeState && handshakeState.data && handshakeState.data.initHostedFieldsPayment;

  const { paymentId } = paymentData || {};

  const handleGoogleSubmit = () => {
    if (paymentId) {
      onPaymentSubmit({ method: PaymentMethod.GOOGLE_PAY, paymentId });
    }
    else {
      logAndTrackError('HOSTED FIELDS: Failed Google pay', 'No payment ID');
    }
  };

  const closeModal = () => {
    toggleModal(null);
  };

  const handleCardClick = () => {
    setModal({
      planInfo: modalState.planInfo,
      modalType: TranzilaModalType.CardInitiation,
      paymentDealType: modalState.paymentDealType,
      bulletinId: modalState.bulletinId || undefined,
    });
  };

  return (
    <Modal
      isOpen
      onClose={closeModal}
      title={t('tranzila.payment.method.title')}
      isFullWidthMainContent
      mobileModalPositionBottom
      desktopModalPositionCenter
      contentWrapperStyle={{
        borderRadius: isDesktop ? 24 : '16px 16px 0 0',
        padding: 0,
      }}
      headerStyle={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        height: 58,
        borderBottom: '1px solid #ececec',
        fontSize: '15px',
        lineHeight: '15px',
      }}
      closeButtonStyle={{
        position: 'absolute',
        left: 16,
        top: '50%',
        transform: 'translateY(-50%)',
        width: 40,
        height: 40,
      }}
      titleStyle={{
        margin: 0,
      }}
    >
      <Wrapper>
        <div className="payment-card">
          <div style={{ visibility: 'hidden', overflow: 'hidden', height: 0, opacity: 0, userSelect: 'none', pointerEvents: 'none' }} id="credit_card_num" />
          <PaymentButton
            isEnabled={true}
            onClick={handleCardClick}
            mode="ghost-darker"
            size="extraLarge"
            fullWidth
            iconPosition="start"
          >
            {t('method.pay.button.text')}
            <CardIcon />
          </PaymentButton>
          {isGoogleEnable && modalState.planInfo.variant !== PromotionPlanVariant.SUBSCRIPTION_MONTHLY ? (
            <>
              <SpacingBlock mTop={2} />
              <PaymentButton
                isEnabled={isGoogleEnable}
                id="payGoogle"
                onClick={handleGoogleSubmit}
                mode="ghost-darker"
                size="extraLarge"
                fullWidth
                iconPosition="start"
              >
                {t('google.pay.button.text')}
                <GoogleIcon />
              </PaymentButton>
            </>
          ) : null}
        </div>
      </Wrapper>
    </Modal>
  );
};
